export default "__VITE_ASSET__0f668ec7__"